import { render } from "./HalloweenComponent.vue?vue&type=template&id=260af35e&scoped=true"
const script = {}

import "./HalloweenComponent.vue?vue&type=style&index=0&id=260af35e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260af35e"]])

export default __exports__